<template>
    <LoadingComponent :props="loading" />

    <section class="mb-18 mt-0 sm:mt-10 sm:mb-20">
        <div class="container">
            <div class="flex items-center justify-between gap-4 mb-2 sm:mb-6">
                <h2 class="text-2xl font-semibold capitalize">{{ $t('label.categories') }}</h2>
                <router-link :to="{ name: 'frontend.product' }" class="text-sm font-medium text-primary hover:underline">
                    {{ $t('label.products') }}
                </router-link>
            </div>

            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4">
                <router-link v-for="category in categories" :key="category.id"
                    :to="{ name: 'frontend.categories.children', params: { slug: category.slug } }"
                    class="group border rounded-xl overflow-hidden bg-white hover:border-primary transition-all duration-300">
                    <div class="category-grid-image-wrap">
                        <img :src="category.cover || category.thumb" :alt="category.name" class="w-full h-36 object-cover">
                        <span class="category-grid-image-overlay"></span>
                        <div class="category-grid-image-description" v-if="category.description">
                            <p class="px-6"><span class="text-lg">{{ category.description }}</span></p>
                        </div>
                    </div>
                    <div class="p-3">
                        <p class="text-base font-medium capitalize group-hover:text-primary text-center transition-all duration-300">{{ category.name }}</p>
                    </div>
                </router-link>
            </div>
        </div>
    </section>
</template>

<script>
import LoadingComponent from "../components/LoadingComponent";
import statusEnum from "../../../enums/modules/statusEnum";

export default {
    name: "CategoryGridComponent",
    components: { LoadingComponent },
    data() {
        return {
            loading: { isActive: false },
            categories: []
        }
    },
    mounted() {
        this.loading.isActive = true;
        this.$store.dispatch("frontendProductCategory/lists", {
            paginate: 0,
            order_column: "id",
            order_type: "asc",
            parent_id: false,
            status: statusEnum.ACTIVE,
        }).then((res) => {
            this.categories = res.data.data || [];
            this.loading.isActive = false;
        }).catch(() => {
            this.loading.isActive = false;
        });
    }
}
</script>
